<template>
    <b-container fluid>
        <b-row class="px-0 py-3">
            <b-col cols="12" md="6" v-for="(item, index) in this.dataList" :key="item.id" class="px-2">
                <div class="block-item mb-4 p-3">
                    <div class="title-item d-flex align-items-center">
                        <img :src="`${publicPath}/img/gep/3.svg`" />
                        <div class="card-number px-2 fw-600 fz-24">
                            {{ item.enName }}
                        </div>

                    </div>
                    <hr />
                    <div class="d-flex fw-500 fz-16 mb-2">
                        <div class="text-grey7">Card Number</div>
                        <div class="ml-auto fw-600">{{ item.payee_userno }}</div>
                    </div>
                    <div class="d-flex fw-500 fz-16 mb-2">
                        <div class="text-grey7">Bank Name</div>
                        <div class="ml-auto fw-600">{{ item.bankName }}</div>
                    </div>
                    <div class="d-flex fw-500 fz-16 mb-2">
                        <div class="text-grey7">Swift Code</div>
                        <div class="ml-auto fw-600">{{ item.swiftCode }}</div>
                    </div>
                    <div class="d-flex fw-500 fz-16 mb-4">
                        <div class="text-grey7">Status</div>
                        <div :class="'ml-auto fw-600 badge-default text-nowrap badge-' + item.status.color">
                            {{ item.status.name }}
                        </div>
                    </div>

                </div>
            </b-col>
            <b-col v-if="dataList.length == 0" cols="12">
                {{ $t("No history found") }}
            </b-col>
        </b-row>
    </b-container>
</template>

<script>


export default {
    data() {
        return {
            publicPath: process.env.BASE_URL !== "/" ? process.env.BASE_URL : "",
            isLoading: false,
            userType: "2",
            // data: [],
            search: "",
            currentPage: 1,
            perPage: 10,
        };
    },
    props: ["dataList"],
    methods: {
        checkError(err) {
            const response = err.response;
            try {
                if (response.status == 401 && response.data.name == "Unauthorized") {
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({
                        path: "/login",
                    });
                } else {
                    if (localStorage.getItem("token")) {
                        var msg = response.data ? response.data.message : err.message;
                        this.$notify({
                            type: "warn",
                            text: msg,
                        });
                    }
                }
            } catch (e) {
                console.log(err);
            }
        },
    },
    mounted() {
    },
    destroyed() { },
};
</script>

<style scoped>
.block-account {
    background: #f8f9fa;
    border-radius: 8px;
}
</style>